export default __webpack_public_path__ + "static/media/smart-makers-anos-iniciais-gray.46846797.jpg";